/*
 * @Author:Dl
 * @Date: 2020-01-03 10:13:51
 * @Description: 正则校验
 * @LastEditors  : Dl
 * @LastEditTime : 2020-01-03 10:14:20
 */
/* eslint-disable */
// 页面地址
export const RE_URL = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
// 邮箱
export const RE_EMAIL = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/
// 变量
export const RE_VAR = /^[a-zA-Z\$_][a-zA-Z\d_]*$/
// 数字
export const RE_NUMBER = /^\d+$/
// 手机号
export const RE_PHONE = /^1[3456789]\d{9}$/
// 收货详细地址
export const RE_ADDR_DETAIL = /[`~!@#$^&*()=|{}':;'\[\]<>?~]/
// 收货人姓名
export const RE_ADDR_NAME = /^[0-9a-zA-Z\u{4e00}-\u{9fa5}]+$/u
